import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { withAuthentication } from "cw-styleguide-react";

class GaHelmet extends Component {
  constructor(props) {
    super(props);

    this.onHelmetChange = this.onHelmetChange.bind(this);
  }

  onHelmetChange(metaTags) {
    // if (window.dataLayer) {
    //   if (metaTags.title instanceof Array) {
    //     window.dataLayer.push({
    //       'event': 'reactpageview',
    //       'customPageTitle': metaTags.title.join(''),
    //       'customPagePath': window.location.href,
    //       'authenticated': this.props.authentication.isAuthenticated,
    //       'authenticatedMethod': this.props.authentication.isAuthenticated ? `${this.props.authentication.getClaim('authenticationSource')} (${this.props.authentication.getClaim('socialIssuer') || 'Email'})` : null,
    //       'authenticatedError': this.props.authentication.error || null
    //     });
    //   } else {
    //     window.dataLayer.push({
    //       'event': 'reactpageview',
    //       'customPageTitle': metaTags.title,
    //       'customPagePath': window.location.href,
    //       'authenticated': this.props.authentication.isAuthenticated,
    //       'authenticatedMethod': this.props.authentication.isAuthenticated ? `${this.props.authentication.getClaim('authenticationSource')} (${this.props.authentication.getClaim('socialIssuer') || 'Email'})` : null,
    //       'authenticatedError': this.props.authentication.error || null
    //     });
    //   }
    // }
  }

  render() {
    return (
      <Helmet onChangeClientState={this.onHelmetChange}>
        {this.props.children}
      </Helmet>
    );
  }
}

export default withAuthentication(GaHelmet);
